/* eslint-disable */
import request from './helpers'

export function listTooltip () {
    return request ({
        url: '/api/v1/tooltip/all',
        method: 'get'
    })
}

export function createTooltip (data) {
    return request ({
        url: '/api/v1/tooltip/create',
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        data
    })
}

export function updateTooltip (id, data) {
    return request ({
        url: '/api/v1/tooltip/' + id,
        method: 'put',
        headers: {
          'Content-Type': 'application/json'
        },
        data
    })
}

export function deleteTooltip (id) {
    return request ({
        url: '/api/v1/tooltip/' + id,
        method: 'delete'
    })
}

export function batchCreateTooltip (data) {
    return request ({
        url: '/api/v1/tooltip/batch/create',
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        data
    })
}
